import "core-js/modules/es6.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ScratchCard from 'vue-scratchcard';
export default {
  name: 'FibScratchCard',
  components: {
    ScratchCard: ScratchCard
  },
  props: {
    cardWidth: {
      type: Number,
      default: 480
    },
    cardHeight: {
      type: Number,
      default: 240
    },
    voucherText: {
      type: String,
      default: ''
    },
    finishPercent: {
      // At the % of foil scratched off specified by this threshold, the rest is automatically removed.
      type: Number,
      default: 50
    },
    forceScratched: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      scratched: false,
      hideHeading: false
    };
  },
  computed: {
    theme: function theme() {
      return this.$store.getters['theme/theme'];
    },
    themeStyle: function themeStyle() {
      return {
        color: this.theme.primaryColor
      };
    },
    voucherStyle: function voucherStyle() {
      return {
        'max-height': "".concat(this.cardHeight, "px"),
        'max-width': "".concat(this.cardWidth, "px"),
        overflow: "hidden"
      };
    }
  },
  watch: {
    scratched: {
      handler: function handler() {
        this.$emit('scratched', this.scratched);
      }
    }
  },
  mounted: function mounted() {
    if (this.forceScratched) {
      this.scratched = true;
    }
  }
};